import { render, staticRenderFns } from "./jev.vue?vue&type=template&id=28d1e864&"
import script from "./jev.vue?vue&type=script&lang=js&"
export * from "./jev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports